// Vøggan (MAR-123): checks that must pass before the cart can go to checkout.
// - <voggan-phone-field>: phone number is required (snippets/voggan-phone-field.liquid).
// - <gift-wrap-details>: gift wrap questions, defined in assets/gift-wrapping.js.
// Each box has validate({ focus }) that returns true when it is complete.

if (!customElements.get('voggan-phone-field')) {
  customElements.define(
    'voggan-phone-field',
    class VogganPhoneField extends BaseElement {
      static messages = {
        empty: 'Skriva telefonnummarið.',
        invalid: 'Kanna telefonnummarið. Tað skal hava í minsta lagi 6 tøl.'
      };

      connectedCallback() {
        super.connectedCallback();

        this.on(this, 'change', this.onChange.bind(this));
        this.on(this, 'input', theme.utils.debounce(this.save.bind(this), 500));
        this.on(this, 'input', () => {
          if (!this.errorElement.hidden) this.validate({ focus: false });
        });

        // A signed-in customer's phone was filled in for them: save it to the cart.
        if (this.hasAttribute('data-needs-save')) this.save();
      }

      get input() {
        return this.querySelector('[data-phone-input]');
      }

      get errorElement() {
        return this.querySelector('[data-phone-error]');
      }

      onChange(event) {
        event.stopPropagation();
        if (!this.errorElement.hidden) this.validate({ focus: false });
        this.save();
      }

      // Saves run one after another, so an older save can never land after a newer one.
      // Checkout also submits the field, so nothing waits on this.
      save() {
        VogganPhoneField.saveQueue = (VogganPhoneField.saveQueue || Promise.resolve()).then(() => {
          const body = JSON.stringify({ attributes: { [this.getAttribute('data-attribute')]: this.input.value.trim() } });
          return fetch(theme.routes.cart_update_url, { ...theme.utils.fetchConfig(), ...{ body } }).catch((error) => console.error(error));
        });

        return VogganPhoneField.saveQueue;
      }

      validate({ focus = true } = {}) {
        const phone = this.input.value.trim();
        const message = !phone
          ? VogganPhoneField.messages.empty
          : phone.replace(/\D/g, '').length < 6
            ? VogganPhoneField.messages.invalid
            : '';

        this.input.classList.toggle('invalid', !!message);
        message ? this.input.setAttribute('aria-invalid', 'true') : this.input.removeAttribute('aria-invalid');
        this.errorElement.textContent = message;
        this.errorElement.hidden = !message;

        if (message && focus) {
          this.scrollIntoView({ behavior: 'smooth', block: 'center' });
          this.input.focus({ preventScroll: true });
        }

        return !message;
      }
    }
  );
}

// Block checkout from the cart page and cart drawer until every check passes.
if (!window.vogganCartCheckoutGuard) {
  window.vogganCartCheckoutGuard = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('button[name="checkout"], input[name="checkout"]');
    if (!button) return;

    const container = button.closest('[id^="MiniCart-"], [id^="MainCart-"]') || document;
    const boxes = Array.from(container.querySelectorAll('voggan-phone-field, gift-wrap-details:not([data-clear])'))
      .filter((box) => typeof box.validate === 'function');
    if (boxes.length === 0) return;

    // Show every box's errors, but only move to the first box that has one.
    let firstInvalid = null;
    boxes.forEach((box) => {
      if (!box.validate({ focus: false }) && !firstInvalid) firstInvalid = box;
    });

    if (firstInvalid) {
      event.preventDefault();
      event.stopImmediatePropagation();
      firstInvalid.validate({ focus: true });
    }
  }, true);
}
